import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useVoucherApprovedAccountsData(companyId: number) {
    const { data: approvedAccounts, isPending: isPendingApprovedAccounts } = useQuery({
        queryKey: ['voucher-approved-accounts-options', companyId],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.voucher.approved-accounts.get', companyId));
            return data;
        },
        placeholderData: [],
    });

    return {
        approvedAccounts,
        isPendingApprovedAccounts,
    };
}
